module.exports = __webpack_public_path__ + "static/media/img9.c602da3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/img9.png
// module id = 168
// module chunks = 0